export default __webpack_public_path__ + "static/media/hero-shoppinglist@3x.8d44c10c.png";